import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Space, Typography} from 'antd';
import {AuthFormContainer} from 'components/AuthFormContainer';
import {observer} from 'mobx-react-lite';
import {appState} from 'store/AppStore';

export enum SignUpStatusCode {
  ConfirmationPending = 1,
  UsernameAlreadyTaken = 2,
  UserCreated = 3,
}

export const EmailCheckView: FC = observer((): JSX.Element => {
  const {t} = useTranslation();
  const {authState} = appState;

  return (
    <AuthFormContainer>
      <Space direction="vertical" className="w-80">
        <Typography.Title className="text-3xl mb-3">{t('Check your email')}</Typography.Title>
        {authState.signUpStatusCode === SignUpStatusCode.UserCreated && (
          <Typography.Paragraph>
            {t('We have sent en email to ')}
            <Typography.Text type="secondary">{authState.signUpEmail}</Typography.Text>
            {t(
              ' to confirm your email address. Please check your inbox, click the link and confirm your email address. Remember to check spam.'
            )}
          </Typography.Paragraph>
        )}
        {authState.signUpStatusCode === SignUpStatusCode.ConfirmationPending && (
          <Typography.Paragraph>
            {t(
              'Within the last 24 hours there was an attempt to register an account with the following email address: '
            )}
            <Typography.Text className="text-blue">{authState.signUpEmail}</Typography.Text>
            {t('. Please check your inbox, click the link and confirm your email address. Remember to check spam.')}
          </Typography.Paragraph>
        )}
        <Typography.Text>
          {t('Didn’t receive the link? ')}
          <Button type="link" className="px-0" onClick={() => authState.resendActivationLink()}>
            {t('Resend')}
          </Button>
        </Typography.Text>
      </Space>
    </AuthFormContainer>
  );
});
